/* THC Hemp Ban advertorial: the countdown, the share link and the video poster.
   Every section is static HTML; this only fills in what cannot be rendered in
   Liquid (a live clock) or needs a click (share, play). */
(function () {
  'use strict';

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function startCountdown(root) {
    var deadline = Date.parse(root.getAttribute('data-deadline'));
    if (isNaN(deadline)) return;
    var out = {
      days: root.querySelector('[data-adv-days]'),
      hours: root.querySelector('[data-adv-hours]'),
      minutes: root.querySelector('[data-adv-minutes]'),
      seconds: root.querySelector('[data-adv-seconds]')
    };

    function tick() {
      var left = deadline - Date.now();
      if (left < 0) left = 0;
      var seconds = Math.floor(left / 1000);
      var days = Math.floor(seconds / 86400);
      var hours = Math.floor((seconds % 86400) / 3600);
      var minutes = Math.floor((seconds % 3600) / 60);
      if (out.days) out.days.textContent = String(days);
      if (out.hours) out.hours.textContent = pad(hours);
      if (out.minutes) out.minutes.textContent = pad(minutes);
      if (out.seconds) out.seconds.textContent = pad(seconds % 60);
    }

    tick();
    setInterval(tick, 1000);
  }

  function wireShare(button) {
    button.addEventListener('click', function () {
      var data = { title: document.title, url: window.location.href };
      if (navigator.share) {
        navigator.share(data).catch(function () {});
        return;
      }
      if (navigator.clipboard) {
        navigator.clipboard.writeText(data.url).then(function () {
          var original = button.textContent;
          button.textContent = 'Link copied';
          setTimeout(function () {
            button.textContent = original;
          }, 2000);
        });
      }
    });
  }

  /* The poster carries the play button; the real video only loads on click so
     the article still opens fast on a phone. */
  function wirePlayer(figure) {
    var button = figure.querySelector('[data-adv-play]');
    if (!button) return;
    button.addEventListener('click', function () {
      var src = figure.getAttribute('data-video-src');
      var embed = figure.getAttribute('data-video-embed');
      var node;
      if (embed) {
        node = document.createElement('iframe');
        node.setAttribute('src', embed);
        node.setAttribute('title', figure.getAttribute('data-video-title') || 'Video');
        node.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        node.setAttribute('allowfullscreen', 'allowfullscreen');
        node.setAttribute('frameborder', '0');
        node.className = 'adv-media__video';
      } else if (src) {
        node = document.createElement('video');
        node.setAttribute('controls', 'controls');
        node.setAttribute('autoplay', 'autoplay');
        node.setAttribute('playsinline', 'playsinline');
        node.className = 'adv-media__video';
        /* A <source> instead of src=: the founder video is a .mov that the CDN
           serves as video/mp4, and the type hint is what gets it played. */
        var source = document.createElement('source');
        source.setAttribute('src', src);
        source.setAttribute('type', 'video/mp4');
        node.appendChild(source);
      } else {
        return;
      }
      figure.innerHTML = '';
      figure.appendChild(node);
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-adv-countdown]').forEach(startCountdown);
    (scope || document).querySelectorAll('[data-adv-share]').forEach(wireShare);
    (scope || document).querySelectorAll('[data-adv-player]').forEach(wirePlayer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Theme editor: a section re-renders without a page load. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
